// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CountDown_wrapper__zzcE4","container":"CountDown_container__K0Kef","event_organizer":"CountDown_event_organizer__cj_4V"};